<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrTooltipV3 as OrTooltip } from '@onereach/ui-components-25';

/** Do not render Tooltip wrapper when tooltip text is not available */
export default defineComponent({
  name: 'OrTooltipWrapper',
  props: {
    tooltip: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: '',
    },
  },
  render(h) {
    if (!this.tooltip) {
      return this.$slots.default ? this.$slots.default[0] : h();
    }

    const props = { content: this.tooltip, placement: this.placement };
    return h(OrTooltip, { props }, this.$slots.default);
  },
});
</script>
